import { UseFormSetError } from 'react-hook-form';
import humps from 'humps';

/// This function sets react hook form field errors based on the error response from a mutation only if the error status is 400.
const setFormFieldMutationError = (error: any, setError: UseFormSetError<Record<string, any>>) => {
  if (error.status && error.status === 400) {
    const fieldErrors = error?.data?.detail || {};
    const camelizedFieldErrors = humps.camelizeKeys(fieldErrors);
    Object.keys(camelizedFieldErrors).forEach((key) => {
      const errorMessage = camelizedFieldErrors[key];
      if (errorMessage) {
        setError(key, {
          type: 'manual',
          message: errorMessage instanceof Array ? errorMessage[0] : errorMessage,
        });
      }
    });
  }
};

export default setFormFieldMutationError;
